export const FISCAL_DEFAULT_COMPARE_PRESET = 'Previous Period';
